import dialogPolyfill from 'dialog-polyfill'

(() => {
  const Moonbase = window.Moonbase || {};
  const dialogs = document.querySelectorAll("dialog");

  Moonbase.Dialog = dialogPolyfill;

  dialogs.forEach((dialog) => {
    dialogPolyfill.registerDialog(dialog);
  });
})();
